import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo } from 'react';
import { FlexContainer } from '../../../CSS/index.js';
const AppContainer = memo(({ children }) => (_jsx(FlexContainer, { as: "main", style: { flex: 1, flexDirection: 'column' }, children: children })));
export default AppContainer;
//# sourceMappingURL=index.js.map